export default async function auth({ next, router, store }) {
  await store.dispatch('login/statusSessionAction');
  if (!store.getters['login/isAuthenticated']) {
    return router.push({ name: 'LoginPage' });
  }
  return next();
}
